var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bsearch",
    attrs: {
      "id": "searchBox"
    }
  }, [_c('div', {
    staticClass: "search-words"
  }, _vm._l((_vm.randomList), function(item, index) {
    return _c('div', {
      key: index,
      class: 'sw-' + index
    }, [_c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "title": item,
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onSearch(item)
        }
      }
    }, [_vm._v(_vm._s(item))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "container search-div"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-11 col-md-7"
  }, [_c('div', {
    staticClass: "form-group-holder"
  }, [_c('Autocomplete', {
    ref: "txt_search",
    attrs: {
      "resetAfter": false,
      "openDirection": "bottom",
      "searchable": true,
      "value": _vm.searchText,
      "preserveSearch": true,
      "selectLabel": "Search",
      "deselectLabel": "Search",
      "selectedLabel": "Search",
      "tag-placeholder": "Search",
      "taggable": true,
      "optionsLimit": 5,
      "placeholder": _vm.$t('common.labels.SearchPlaceHolder'),
      "options": _vm.suggestions,
      "id": "example-text-input"
    },
    on: {
      "tag": _vm.addTag,
      "search-change": _vm.getSuggestions,
      "select": _vm.onSearch,
      "remove": _vm.onSearch
    }
  })], 1)])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f79bd7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/bannerSearch.vue
// module id = 4Bwl
// module chunks = 1